const items = [
  { id: 0, name: 'certification', color: '#92c0e7', expert: ['Andrea de Almieda'] },
  { id: 1, name: 'diversity', color: '#fcb415', expert: ['Brianna Kerr'] },
  { id: 2, name: 'profit structure', color: '#f16a22', expert: ['Many Experts'] },
  { id: 3, name: 'development', color: '#0042a6', expert: ['Caitlin Barrett'] },
  { id: 4, name: 'transparency', color: '#038442', expert: ['Mat Bowtell'] },
  { id: 5, name: 'measurement', color: '#cf256d', expert: ['Greg Norris', 'Chris Ennis (+ Ben Walta)'] }
  //{ id: 6, name: 'blue economy', color: '#256ddb', expert: ['Gunter Pauli'] }
];

export default items;
